import { Box, Flex, Link } from '@chakra-ui/react';
import Typography from 'src/components/Typography';
import { MEVO_PRIVACY_URL } from 'src/helpers/defaultValues';
import { TermsOfUse } from 'src/services/termsOfUse';

interface TermsOfServiceLinkProps {
  termsOfUse: TermsOfUse | null;
}

export function TermsOfServiceLink({ termsOfUse }: TermsOfServiceLinkProps) {
  return (
    <Box mt="30px" mb="20px" textAlign="center">
      <Typography model="body" size="normal" weight="regular">
        Ao continuar, você concorda com os nossos
      </Typography>
      <Flex justify="center" gap="4px" flexWrap="wrap">
        <Link href={termsOfUse?.termUrl} target="_blank" rel="noreferrer">
          <Typography model="body" size="normal" weight="regular" underline>
            Termos de Serviço
          </Typography>
        </Link>
        <Typography model="body" size="normal" weight="regular">
          e
        </Typography>
        <Link href={MEVO_PRIVACY_URL} target="_blank" rel="noreferrer">
          <Typography model="body" size="normal" weight="regular" underline>
            Política de Privacidade
          </Typography>
        </Link>
      </Flex>
    </Box>
  );
}
